'use client';
import { FormSubmitButtons } from '@/shared/components/features/form/FormSubmitButtons';
import { Loading } from '@/shared/components/parts/Loading';
import { MainContainer } from '@/shared/components/parts/MainContainer';
import { Spacer } from '@/shared/components/parts/Spacer';
import { useLogoutConfirm } from './index.hook';

export const LogoutConfirm: React.FC = () => {
  const { state, invokeLogout, isLoading } = useLogoutConfirm();

  return (
    <>
      {(state.pageStatus === 'INIT' ||
        state.pageStatus === 'POST_PROCESS' ||
        state.pageStatus === 'COMPLETE') && <Loading />}
      {state.pageStatus === 'CONFIRM' && (
        <MainContainer>
          <Spacer level={3} />
          <div className="tw-text-h2 tw-text-main-100">ログアウト</div>
          <Spacer level={2} />
          <div>
            H2Uからログアウトしますか？
            <br />
            再度ログインするには、ログインIDとパスワードが必要です。
          </div>
          <Spacer level={3} />
          <FormSubmitButtons
            buttons={[
              {
                buttonType: 'button',
                text: 'ログアウト',
                onClick: () => {
                  invokeLogout();
                },
                isLoading,
              },
              {
                buttonType: 'link',
                text: 'キャンセル',
                buttonStyle: 'secondary',
                href: '/',
              },
            ]}
          />
          <Spacer level={4} />
        </MainContainer>
      )}
    </>
  );
};
